import * as React from 'react';

import { SidebarContext } from '../sidebar-context';
import type { SidebarContextValue } from '../types/sidebar-provider-variants-types';

export function useSidebar(): SidebarContextValue {
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider.');
  }
  return context;
}
